import { render, staticRenderFns } from "./AgencyDocumentsReadOnlyView.vue?vue&type=template&id=3e19940e&scoped=true&"
import script from "./AgencyDocumentsReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./AgencyDocumentsReadOnlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e19940e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
